/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type missionControlHeader_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Flatfile_viewer$ref: FragmentReference;
declare export opaque type Flatfile_viewer$fragmentType: Flatfile_viewer$ref;
export type Flatfile_viewer = {|
  +id: string,
  +missionControlData: ?{|
    +id: string,
    +companies: ?$ReadOnlyArray<?{|
      +id: string,
      +companyId: ?number,
      +name: ?string,
    |}>,
    +dataMigration: ?{|
      +id: string,
      +activeUserEmails: ?$ReadOnlyArray<?string>,
      +projects: ?$ReadOnlyArray<?{|
        +id: string,
        +name: ?string,
        +companyProjectId: ?number,
        +autoRemaining: ?boolean,
        +statusColumns: ?$ReadOnlyArray<?{|
          +id: string,
          +name: ?string,
        |}>,
      |}>,
    |},
    +dataMigrationLog: ?$ReadOnlyArray<?{|
      +id: string,
      +company: ?string,
      +project: ?string,
      +date: ?string,
      +person: ?string,
      +status: ?string,
      +errorMessage: ?string,
    |}>,
  |},
  +$fragmentRefs: missionControlHeader_viewer$ref,
  +$refType: Flatfile_viewer$ref,
|};
export type Flatfile_viewer$data = Flatfile_viewer;
export type Flatfile_viewer$key = {
  +$data?: Flatfile_viewer$data,
  +$fragmentRefs: Flatfile_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "companyId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Flatfile_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlCompanyType",
          "kind": "LinkedField",
          "name": "companies",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "companyId",
              "variableName": "companyId"
            }
          ],
          "concreteType": "MissionControlDataMigration",
          "kind": "LinkedField",
          "name": "dataMigration",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "activeUserEmails",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MissionControlProjectType",
              "kind": "LinkedField",
              "name": "projects",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyProjectId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "autoRemaining",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MissionControlProjectStatusColumnType",
                  "kind": "LinkedField",
                  "name": "statusColumns",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlDataMigrationLogItemType",
          "kind": "LinkedField",
          "name": "dataMigrationLog",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "project",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "person",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "errorMessage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "missionControlHeader_viewer"
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '048b82aed38e72e1e8c982904f774ca5';

module.exports = node;
